import React from "react";
import { GovShareButton } from "@/components/governance/GovShare";
import { govActionLabel, govStatusTone } from "@/lib/governance";
import { Badge } from "@/components/primitives";

// Rich proposal sharing — thin wrapper over GovShareButton that supplies the
// proposal-specific preview card (live DRep tally) + the backend share path.
export const ProposalShare = ({ txHash, certIndex, d }) => {
  const label = govActionLabel(d?.type);
  const title = (d?.metadata?.title || "").trim() || label;
  const tweetText = `${title} · Cardano governance action (${d?.status || ""})`;

  const vc = d?.vote_counts?.drep || {};
  const y = Number(vc.yes) || 0;
  const n = Number(vc.no) || 0;
  const a = Number(vc.abstain) || 0;
  const tot = y + n + a;
  const pct = (v) => (tot > 0 ? `${((v / tot) * 100).toFixed(0)}%` : "0%");

  return (
    <GovShareButton
      tid="proposal"
      heading="Share this governance action"
      sharePath={`governance/proposal/${txHash}/${certIndex}`}
      title={title}
      tweetText={tweetText}
    >
      <div className="flex items-center justify-between gap-3">
        <span className="text-[9px] uppercase tracking-[0.25em] mono text-[#22d3ee]">ada explorer · governance</span>
        <Badge tone={govStatusTone(d?.status)}>{d?.status || "—"}</Badge>
      </div>
      <div className="text-[10px] uppercase tracking-[0.2em] mono text-[#22d3ee]/80">{label}</div>
      <div className="text-[18px] font-heading font-semibold text-foreground leading-snug break-words">{title}</div>
      <div className="pt-1 space-y-1.5">
        <div className="text-[9px] uppercase tracking-[0.2em] mono text-muted-foreground">DRep votes</div>
        <div className="flex h-2 w-full overflow-hidden rounded-full bg-muted/20">
          <div className="bg-emerald-500" style={{ width: pct(y) }} />
          <div className="bg-red-500" style={{ width: pct(n) }} />
          <div className="bg-muted-foreground/40" style={{ width: pct(a) }} />
        </div>
        <div className="text-[10px] mono text-muted-foreground">Yes {y} · No {n} · Abstain {a}</div>
      </div>
      <div className="text-[10px] mono text-muted-foreground/70 pt-1">
        Submitted epoch {d?.submitted_epoch ?? "—"} · Expires epoch {d?.expires_after_epoch ?? "—"}
      </div>
    </GovShareButton>
  );
};
